"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nuraminis": {
    "8bbc903b": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "funtana-bella": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26b9c8f3": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "funtana-cattodixi": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b49bccad": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "funtanedda": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92812cf9": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "pratza-de-cresia": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "06450661": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "pratza-funtanamanna": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c5e8d83": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-su-cramu": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f42aaa4": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "s-arazia": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0fa0f252": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "s-arriu-gloria": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec51550b": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "santu-sebastianu": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ac4020f": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "santu-xori": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9234a2cb": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "su-mobinu-de-is-pegus": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "333efb75": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "skipSearch": false
    }],
    "su-procciu": [{
      "hkey": "4ca6c56e",
      "slug": "nuraminis",
      "name": "Nuraminis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;